/* eslint-disable @typescript-eslint/naming-convention */
export class AppVariables {
	public static readonly LONG_TEXT_LIMIT = 100;
	public static readonly PRIMARY_KEYS_MAX_LENGTH = 10_000;
	public static readonly MAXIMUM_NUMBER_OF_RECORDS = 1_000_000_000;
	public static readonly NUMBER_RECORDS_PRECISION = 0.01;
	public static readonly NUMBER_OF_ENTITIES_TO_DISPLAY_STEP = 15;
	public static readonly NUMBER_OF_PROJECTS_TO_DISPLAY_STEP = 15;
	public static readonly END_ORDER = 999;
	public static readonly DEFAULT_FIELD_WIDTH = 7;
	public static readonly INPUT_GRID_SIZE = 7;
	public static readonly TEXT_AREA_GRID_SIZE = 12;
	public static readonly FORM_SCROLL_UP_DURATION = 1500;
	public static readonly LOGIN_FORM_USERNAME_CREDENTIAL = 'mvp'; // remove?
	public static readonly LOGIN_FORM_PASSWORD_CREDENTIALS = 'mvp'; // remove?
	public static readonly DATE_COLUMN_DEFAULT_VALUE = 'GETDATE()';
	public static readonly I18N_SUPPORTED_LANGUAGES = [
		'en-CA', // English (Canada)
		'fr-CA', // French (Canada)
		'ro', // Romania
		'ru', // Russian
		'pt', // Portuguese
		'pt-BR', // Portuguese (Brazil)
		'es', // Spanish
		'es-MX' // Spanish (Mexico)
	];
	public static readonly I18N_SUPPORTED_LANGUAGES_FALLBACK = 'en-CA';
	// max width of 14 is meant for numeric values imported as numbers in rxdb - this is a JS limitation for computing numbers
	public static readonly NUMERIC_COLUMN_MAX_WIDTH = 14;
	public static readonly INTERNAL_STORAGE_REF_TABLE_PREFIX = '_REF_TABLE_';
	public static readonly MAX_TABLES_NUMBER_SUPPORTED = 750;
	public static readonly MAX_TABLES_NUMBER_SUPPORTED_IOS = 70;
	public static readonly IMPORT_TRANSFER_OUT_DATA_STRUCTURE_OPTION = 'import_transfer_out_data_structure_option';
	public static readonly STANDALONE_PROJECT_NAME = 'STANDALONE';
	public static readonly ENCRYPTION_KEY = 'yourSecretKey123';
	public static readonly ENCRYPTION_iv = 'HR$2pIjHR$2pIj12';
}
